angular.module('app')
  .directive('order', function (appCacheFactory) {
    return {
      restrict: 'A',
      scope: {
        order: '=',
        onOrder: '&',
      },
      link: (scope, element, attrs) => {
        element.css({ cursor: 'pointer' });

        element.on('click', () => {
          scope.$apply(() => {
            if (scope.order.by === attrs.orderBy) {
              // toggle "how"
              scope.order.how = { asc: 'desc', desc: 'asc' }[scope.order.how];
            } else {
              scope.order.by = attrs.orderBy;
            }

            scope.onOrder(); // callback
          });

          if (scope.order.key) {
            appCacheFactory.put(scope.order.key, scope.order);
          }
        });

        function setClass() {
          element.removeClass('sorted-asc sorted-desc');

          if (scope.order.by === attrs.orderBy) {
            element.addClass({ asc: 'sorted-asc', desc: 'sorted-desc' }[scope.order.how]);
          }
        }

        scope.$watch(() => scope.order, () => {
          setClass();
        }, true);
      },
    };
  });
